<template>
 
  <!-- <ion-app> -->
      <ion-vue-router />
     
  <!-- </ion-app> -->

</template>
<script>
export default {
  name:"app",
  data(){
    return {
     
    }
  },
  mounted(){
    // console.log("App is mounted ")
  // if(this.$isWeb &  !this.$isIOS ){
  //   this.$router.push("/")
  // }

  }
  
}
</script>

<style>

body{
  
     min-height: 100%;
     
}



</style>
